import PeopleIcon from "@mui/icons-material/People";
import React from "react";
import { ListStateIcon } from "../ListStateIcon/ListStateIcon";
import { Translations } from "ui/Scripts/source/models/translations";

interface IListStateIconPersonsProps {
    noMargin?: boolean;
    tooltip?: string;
}

export const ListStateIconPersons = (props: IListStateIconPersonsProps) => {
    return (
        <ListStateIcon
            tooltip={props.tooltip ?? Translations.Users}
            icon={PeopleIcon}
            noMargin={props.noMargin}
        />
    );
};
